import classNames from 'classnames'
import React from 'react'
import {Button, HoverStyles} from 'wix-ui-tpa/cssVars'
import {NoEventsButtonProps} from './interfaces'
import {classes} from './no-events-button.st.css'

export const NoEventsButton = (props: NoEventsButtonProps) => (
  <Button {...props} className={classNames(classes.root)} hoverStyle={HoverStyles.underline} />
)
